<template>
  <!-- 大图 -->
  <a class="infoflow-item big" target="_blank" :href="url" v-if="adStyle === 1">
    <YorkbbsImage class="infoflow-cover__big" :src="pcImages[0] | webpFormat(650)" v-if="pcImages[0]"></YorkbbsImage>
    <div class="infoflow-title e-2" v-if="text">{{ text }}</div>
    <div class="infoflow-extend">
      <span class="infoflow-adv">广告</span>
    </div>
  </a>
</template>
<script>
export default {
  name: 'ItemInfoflow',
  props: { data: Object },
  computed: {
    material() {
      return this.data.material || {};
    },
    // 信息流广告样式 1:大图 2:小图 3:3图 4:文字
    adStyle() {
      return this.material.pcAdStyle||adStyle;
    },
    pcImages() {
      return this.material.pcImages || [];
    },
    url() {
      return this.material.url;
    },
    // 标题，可选
    text() {
      return this.material.text;
    },
    // 标题颜色
    fontColor() {
      return this.material.fontColor;
    },
    // 标题是否加粗
    fontWeight() {
      return this.material.fontWeight;
    },
    textFiled1() {
      return this.material.textFiled1;
    },
    textFiled2() {
      return this.material.textFiled2;
    },
    textFiled3() {
      return this.material.textFiled3;
    },
    textFiled4() {
      return this.material.textFiled4;
    },
  },
};
</script>
<style lang="scss" scoped>
.infoflow-item {
  box-sizing: border-box;
  padding: 10px;
  display: block;
  width: 280px;
  position: relative;
  border: 1px solid transparent;
  &:hover {
    border-color: #f5f5f5;
    box-shadow: 0 15px 20px rgba($color: #000000, $alpha: 0.1);
    border-radius: 6px;
  }
}
.infoflow-title {
  margin-bottom: 5px;
  margin-top: 8px;
  line-height: 25px;
  font-size: 18px;
  &:hover {
    color: var(--primary-color);
  }
}
.infoflow-cover__big {
  width: 100%;
  height: 195px;
  border-radius: 6px;
  border: 1px solid #eee;
}
.infoflow-extend {
  margin-top: 12px;
}
.infoflow-adv {
  font-size: 14px;
  line-height: 20px;
  color: var(--text-color-9);
}
</style>
